import React from 'react'
import { ThingCalendar } from '@fs/zion-icon'
import { css } from '@linaria/core'
import PropTypes from 'prop-types'
import { ComboMenu } from '@fs/zion-ui'
import { boolAttr } from '@fs/zion-frontend-friends'

const stdContainerCss = css`
  /* style overrides */
  max-width: 600px;
  min-width: 80px;

  & > * {
    width: 100%;
  }
  &[tighten] div[role='button'] {
    padding-top: 4px;
    padding-bottom: 4px;
    min-height: unset;
  }
  & div[side='left'][is-icon] {
    margin-left: 0;
  }
`
export default function DateSelect({ standard, isStandard, suggestions, onChange, showDenseUI }) {
  return standard ? (
    <div className={stdContainerCss} tighten={boolAttr(showDenseUI)}>
      {!isStandard && (
        <ComboMenu
          fullWidth
          Icon={ThingCalendar}
          options={suggestions}
          selectedOption={standard}
          setSelectedOption={onChange}
        />
      )}
    </div>
  ) : null
}

DateSelect.propTypes = {
  /** The currently selected place standard */
  standard: PropTypes.shape({
    /** ListItem props are available here as well. */
    value: PropTypes.any,
  }),

  /** Whether the associated input was standardized or whether it remained original text. */
  isStandard: PropTypes.bool,

  /** List of suggestions the user may select a standard option from. */
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      /** ListItem props are available here as well. */
      value: PropTypes.any,
    })
  ),

  /** An event handler called whenever the user selects a standard */
  onChange: PropTypes.func,
}
